export default "__VITE_ASSET__f2bed15f__"